module.exports = __webpack_public_path__ + "static/img/xihongshi.21297230.png";